import React from 'react';

export default function EngagementLegend() {
  const items = [
    { bg: '#22c55e', border: '#22c55e', label: 'Quente' },
    { bg: '#eab308', border: '#eab308', label: 'Morno' },
    { bg: '#94a3b8', border: '#94a3b8', label: 'Frio' },
    { bg: 'transparent', border: '#cbd5e1', label: 'Não abriu' },
  ];
  return (
    <div style={{ display: 'flex', gap: '1rem', alignItems: 'center', fontSize: '0.75rem', color: '#64748b' }}>
      {items.map(i => (
        <div key={i.label} style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
          <div style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: i.bg, border: `2px solid ${i.border}` }} />
          <span>{i.label}</span>
        </div>
      ))}
    </div>
  );
}
